var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ElButton',{ref:"button",staticClass:"px-button",class:{
    'is-compact': _vm.isCompact,
    'is-fluid': _vm.isFluid,
    'icon-right': _vm.iconPosition === 'right',
  },attrs:{"size":_vm.size,"type":_vm.type,"disabled":_vm.disabled,"loading":_vm.loading},on:{"click":_vm.onButtonClick}},[(!!_vm.icon)?_c('PxIcon',{attrs:{"name":_vm.icon,"use-inline-style":false}}):_vm._e(),(!_vm.isCompact)?_c('div',[_vm._v(_vm._s(_vm.label))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }